<template>
	<!-- 财政奖励 -->
	<div class="all">
		<div class="bgImg">
			<img src="../assets/bgIcon_1.png" />
		</div>
		<div class="bgImg bgImgOne">
			<img src="../assets/bgIcon_2.png" />
		</div>
		<div class="bgImg bgImgTwo">
			<img src="../assets/bgIcon_3.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_4.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_5.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_6.png" />
		</div>
		<div class="drawerBox drawerBoxOther">
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
				<el-form-item label="企业名称" prop="company">
					<el-input v-model="form.company" placeholder="请输入企业名称"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" prop="mobile">
					<el-input v-model="form.mobile" placeholder="请输入手机号">
						<el-button type="text" class="code" slot="suffix" @click="sendYzm" :disabled="countDisable">
							{{ count }}</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="authCode">
					<el-input v-model="form.authCode" placeholder="请输入验证码"></el-input>
				</el-form-item>
				<el-button v-preventReClick @click="submitReserved('form')" class="submit">预约咨询</el-button>
			</el-form>
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_7.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_8.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_9.png" />
		</div>
		<div class="cooperationBox">
			<img @click="openCooperation" class="cooperationImg" :class="[{'r1': shrinkPacket}, {'r2': !shrinkPacket}]"
				src="../assets/icon6.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_10.png" />
		</div>
		<div class="bgImg bgImgThree">
			<img src="../assets/bgIcon_11.png" />
		</div>
		<div class="bgImg bgImgThree" style="margin-bottom: .1rem;">
			<img src="../assets/bgIcon_12.png" />
		</div>
		<div class="bgImg bgImgThree" style="margin-bottom: 0;">
			<img src="../assets/bgIcon_13.png" />
		</div>
		<el-drawer title="合作联系" :visible.sync="drawer" direction="btt" :before-close="handleClose">
			<div style="font-size: .12rem;font-weight: 400;color: #BDBDBD;margin-bottom: .2rem;margin-left: .12rem;margin-top: .08rem;">提交后会安排客服联系您，请耐心等待~</div>
			<div class="drawerBox">
				<el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
					<el-form-item label="企业名称" prop="company">
						<el-input v-model="form.company" placeholder="请输入企业名称"></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input v-model="form.name" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="mobile">
						<el-input v-model="form.mobile" placeholder="请输入手机号">
							<el-button type="text" class="code" slot="suffix" @click="sendYzm" :disabled="countDisable">
								{{ count }}</el-button>
						</el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="authCode">
						<el-input v-model="form.authCode" placeholder="请输入验证码"></el-input>
					</el-form-item>
					<el-button v-preventReClick @click="submitReserved('form')" class="submit">提交</el-button>
				</el-form>
			</div>
		</el-drawer>
		<el-drawer :visible.sync="drawerLookPrice" direction="btt" :before-close="handleClose">
			<div class="drawerBox" style="margin-top: 0;">
				<el-form ref="form" :model="form" :rules="rules" size="small">
					<el-form-item prop="mobile">
						<el-input v-model="form.mobile" placeholder="请输入手机号">
							<el-button type="text" class="code" slot="suffix" @click="sendLoginYzm"
								:disabled="countDisable">{{ count }}</el-button>
						</el-input>
					</el-form-item>
					<el-form-item prop="authCode">
						<el-input v-model="form.authCode" placeholder="请输入验证码"></el-input>
					</el-form-item>
					<el-button class="submit" @click="submitSucc">确定</el-button>
				</el-form>
			</div>
		</el-drawer>
		<div v-if="showTips" class="showTips">{{this.showTipsText}}</div>
	</div>
</template>
<!-- "serve": "vue-cli-service serve  --host 0.0.0.0", -->
<script>
	import Axios from "axios";
	export default {
		name: 'index',
		data() {
			return {
				drawer: false,
				drawerLookPrice: false,
				form: {
					name: '',
					mobile: '',
					authCode: '',
					company: '',
				},
				isShow: '0',
				count: "获取验证码",
				countDisable: false,
				inter: null,
				rules: {
					company: [{
						required: true,
						message: "请输入企业名称",
						trigger: "blur"
					}, ],
					name: [{
							required: true,
							message: "请输入姓名",
							trigger: "blur"
						},
						{
							min: 3,
							max: 20,
							message: "长度在 3 到 5 个字符",
							trigger: "blur"
						},
					],
					mobile: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur",
						},
						{
							min: 11,
							max: 11,
							message: "请输入11位手机号码",
							trigger: "blur"
						},
						{
							pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[389])\d{8}$/,
							//pattern: /^1[3456789]\d{9}$/,
							message: "请填写正确的手机号码",
						}
					],
					authCode: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}, ],
				},
				todayPriceList: [{
					sheng: '湖南',
					edu: '10万/月',
					qiu: '身份证',
					lv: '5.5%',
				}, {
					sheng: '福建',
					edu: '10万/月',
					qiu: '四要素',
					lv: '5.3%',
				}, {
					sheng: '江西',
					edu: '10万/月',
					qiu: '四要素',
					lv: '5.3%',
				}, {
					sheng: '天津',
					edu: '15万/月',
					qiu: '身份证',
					lv: '5.6%',
				}, {
					sheng: '河南',
					edu: '3万/月',
					qiu: '身份证',
					lv: '5.3%',
				}, {
					sheng: '湖北',
					edu: '10万/月',
					qiu: '四要素',
					lv: '5.3%',
				}],
				taxBurdenList: [{
					sheng: '100-300万',
					edu: '5%',
					qiu: '20%',
					lv: '24%',
					lv2: '2.86%',
					lv3: '88%',
				}, {
					sheng: '300万以上',
					edu: '25%',
					qiu: '20%',
					lv: '40%',
					lv2: '2.86%',
					lv3: '93%',
				}, {
					sheng: '高新技术企业',
					edu: '15%',
					qiu: '20%',
					lv: '32%',
					lv2: '2.86%',
					lv3: '91%',
				}],
				todayPriceList2: [{
					sheng: '海南',
					edu: '10万/月',
					qiu: '50万/月',
					lv: '电子票',
					lv2: '实名',
					lv3: '2.15%',
				}, {
					sheng: '河南',
					edu: '10万/月',
					qiu: '500万/年',
					lv: '纸质票',
					lv2: '-',
					lv3: '2.75%',
				}],
				showTips: false,
				showTipsText: '',
				shrinkPacket: false,
				mathNum:[],
				urlId: '',
			}
		},
		directives: {
			preventReClick: {
			// 指令的定义
				inserted(el, binding) {
				el.addEventListener('click', () => {
					if (!el.disabled) {
					el.disabled = true
					setTimeout(() => {
					el.disabled = false
					}, binding.value || 2000)
					}
				})
				}
			}
		},
		created() {
			if (sessionStorage.getItem('isShow') != null) {
				this.isShow = sessionStorage.getItem('isShow')
			}
			this.startRotate()
			let num=Math.floor(Math.random() * (200 - 50) ) + 50
			this.mathNum=num.toString().split('')

			var url = window.location.href ; 
			var index = url.lastIndexOf("\/");
			this.urlId = url.substring(index + 1,url.length);
			this.getClick()
		},
		destroyed() {
			clearInterval(this.inter);
		},
		methods: {
			getClick(){
				let data={
					id:this.urlId,
				}
				this.$http.get("api/note/click_through", data).then((res) => {

				})
			},
			startRotate() {
				clearInterval(this.timer);
				this.timer = setInterval(() => {
					this.shrinkPacket = !this.shrinkPacket
				}, 150);
			},
			callPhone(num) {
				window.location.href = 'tel://' + num
			},
			lookPrice() {
				this.drawerLookPrice = true
			},
			openCooperation() {
				this.drawer = true
				this.form.company=''
				this.form.mobile=''
				this.form.authCode=''
				this.$refs.form.clearValidate();
			},
			handleClose() {
				this.drawer = false
				this.drawerLookPrice = false
				this.inter = null
				this.form.company=''
				this.form.mobile=''
				this.form.authCode=''
				this.$refs.form.clearValidate();
				this.count = '获取验证码'
			},
			countDown() {
				let self = this;
				self.count = 60;
				self.countDisable = true;
				self.inter = setInterval(function() {
					// console.log("进来");
					if (self.count > 0) {
						self.countDisable = true;
						self.count--;
						// console.log(self.count, "倒计时");
					} else {
						clearInterval(self.inter);
						self.count = "获取验证码";
						self.countDisable = false;
						self.inter = null;
					}
				}, 1000);
			},
			sendLoginYzm() {
				let self = this;
				if (!this.form.mobile) {
					this.showTips = true
					this.showTipsText = '请输入手机号'
					setTimeout(() => {
						this.showTips = false
					}, 2000)
					return;
				}
				let data = {
					mobile: this.form.mobile,
				};
				this.countDown();
				this.$http.post("api/login/send_sms", data).then((res) => {
					console.log(res, "返回验证码");
					if (res.err == 0) {} else {
						clearInterval(self.inter);
						self.count = "获取验证码";
						self.countDisable = false;
						self.inter = null;
						this.showTips = true
						this.showTipsText = res.info
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					}
				});
			},
			sendYzm() {
				let self = this;
				if (!this.form.mobile) {
					this.showTips = true
					this.showTipsText = '请输入手机号'
					setTimeout(() => {
						this.showTips = false
					}, 2000)
					return;
				}
				let data = {
					mobile: this.form.mobile,
				};
				this.countDown();
				this.$http.post("api/login/send_sms", data).then((res) => {
					console.log(res, "返回验证码");
					if (res.err == 0) {} else {
						clearInterval(self.inter);
						self.count = "获取验证码";
						self.countDisable = false;
						self.inter = null;
						this.showTips = true
						this.showTipsText = res.info
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					}
				});
			},
			submitReserved(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.saveReserved();
					} else {
						this.showTips = true
						this.showTipsText = '有必填信息没填写'
						setTimeout(() => {
							this.showTips = false
						}, 2000)
						return false;
					}
				});
			},
			saveReserved() {
				let data = {
					name: this.form.name,
					telephone: this.form.mobile,
					authCode: this.form.authCode,
					company: this.form.company,
					investmentArea: '合作联系',
				}
				this.$http.post("api/note/reserved_capital", data).then((res) => {
					if (res.err == 0) {
						this.drawer = false
						this.isShow = '1'
						sessionStorage.setItem('isShow', this.isShow)
						this.clear()
						this.search()
						
						this.showTips = true
						this.showTipsText = '发送成功'
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					} else {
						this.showTips = true
						this.showTipsText = res.info
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					}
				})
			},
			submitSucc() {
				let data = {
					telephone: this.form.mobile,
					authCode: this.form.authCode,
					investmentArea:'获取价格'
				}
				this.$http.post("api/note/reserved_capital", data).then((res) => {
					if (res.err == 0) {
						this.drawerLookPrice = false
						this.isShow = '1'
						sessionStorage.setItem('isShow', this.isShow)
						this.clear()
						this.search()
						this.showTips = true
						this.showTipsText = '发送成功'
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					} else {
						this.showTips = true
						this.showTipsText = res.info
						setTimeout(() => {
							this.showTips = false
						}, 2000)
					}
				})
			},
			search() {
				this.$nextTick(() => {
					this.$refs.table.doLayout()
				})
			},
			clear() {
				this.form.name = ''
				this.form.mobile = ''
				this.form.authCode = ''
				this.form.company = ''
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.all {
		background: #FF6E35;
		width: 100%;
		padding-bottom: .8rem;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		.bgImg{
			// width: 100%;
			box-sizing: border-box;
			img{
				width: 100%;
				display: block;
			}
		}
		.bgImgOne{
			margin-top: .1rem;
			padding-left: .07rem;
			padding-right: .08rem;
			margin-bottom: .2rem;
		}
		.bgImgTwo{
			margin: 0 .02rem;
			padding-left: .07rem;
			padding-right: .08rem;
			margin-bottom: .2rem;
		}
		.bgImgThree{
			margin: 0 .08rem;
			margin-bottom: .2rem;
		}
		.bgImgFour{
			margin: 0 .08rem;
			margin-top: .2rem;
		}

		.cooperationBox {
			position: fixed;
			z-index: 100;
			right: 0;
			top: 40%;
			transform: translateY(-50%);

			.cooperationImg {
				width: .84rem;
				height: .85rem;
			}

			.r1 {
				transform: rotate(-5deg);
			}

			.r2 {
				transform: rotate(3deg);
			}
		}

		/deep/ .el-drawer.btt {
			height: auto !important;
			border-radius: .12rem .12rem 0rem 0rem;
		}

		/deep/ .el-drawer__header {
			padding: .13rem .13rem 0 0;
			margin-bottom: 0;

			span {
				font-size: .14rem;
				font-weight: 500;
				color: #000000;
				margin-top: .08rem;
				margin-left: .12rem;
			}

			.el-drawer__close-btn {
				font-size: .14rem;
				margin-bottom: 0.08rem;
			}
		}
		.drawerBoxOther{
			margin: 0 .08rem;
			background: #fff;
			border: .02rem solid #000000;
			border-radius: .16rem;
			padding: .12rem .1rem !important;
			margin-top: 0 !important;
			margin-bottom: .2rem;
			.el-input{
				border-radius: .08rem;
				border: .01rem solid #CCCCCC;
				/deep/ .el-input__inner {
					border: none !important;
				}
			}
		}
		.drawerBox {
			padding: 0 .12rem;
			margin-top: .2rem;

			/deep/ .el-input--suffix input {
				padding-right: 40%;
			}
			/deep/ .el-input--small .el-input__inner {
				height: .37rem;
				line-height: .37rem;
				border-radius: .08rem;
				border: 0.01rem solid #CCCCCC;
				font-size: .12rem;
				font-weight: 400;
			}

			.code {
				font-size: .12rem;
				font-weight: 400;
				color: #FF5312;
				margin-right: .12rem;
				padding: 0;
				padding-left: .12rem;
				border-left: .01rem solid #EAEAEA;
			}

			/deep/ .el-input__suffix {
				display: flex;
				align-items: center;
			}

			.submit {
				margin-top: .2rem;
				width: 100%;
				height: .37rem;
				background: linear-gradient(180deg, #FF5E29 0%, #FF3012 100%);
				border-radius: .08rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: .14rem;
				font-weight: 500;
				color: #FFFFFF;
				border: none;
				line-height: normal;
			}
		}
	}

	/deep/ .el-table .cell {
		line-height: .23rem !important;
	}

	/deep/ .el-drawer__body {
		overflow: inherit !important;
	}

	/deep/ .el-form-item--small.el-form-item {
		margin-bottom: .12rem;
		display: flex;
		flex-direction: column;
	}

	

	/deep/ .el-form-item__label {
		font-size: .13rem;
		font-weight: 400;
		color: #000000;
		line-height: .18rem !important;
	}

	/deep/ .el-form-item__label:before {
		color: #FF2020 !important;
		margin-right: 0 !important;
		font-size: .13rem;
	}

	/deep/ .el-table td.el-table__cell {
		border-bottom: .01rem solid #FFF3EF !important;
	}

	/deep/ .el-table th.el-table__cell.is-leaf {
		border-bottom: .01rem solid #FFF3EF !important;
	}

	/deep/ .el-table .cell {
		font-size: .11rem !important;
	}

	/deep/ .el-table__body .cell {
		font-weight: 400;
	}

	/deep/ .el-table__header {
		table-layout: inherit;
		width: 100% !important;
	}

	/deep/ .el-table__body {
		table-layout: inherit;
		width: 100% !important;
	}

	.mask {
		width: .34rem;
		height: .18rem;
		background: #F1EEEE;
		filter: blur(.02rem);
		margin: 0 auto;
	}

	.showTips {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 3000;
		width: 2.66rem;
		padding: .16rem 0;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.75);
		border-radius: .08rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: .14rem;
		font-weight: 400;
		color: #FFFFFF;
	}
</style>
